import { Button } from "@repo/ui4/components/Button";
import { AlertCircle } from "lucide-react";

const homeHost = process.env.NEXT_PUBLIC_HOME_HOST;

type ErrorScreenProps = {
  message: string;
  showHomeLink?: boolean;
  onSelectWorkspace?: () => void;
  // NOTE: セッションは残っているが復帰できない状態から抜け出すための導線。
  //       ID セッションを破棄する（他アプリを含めてサインアウトされる）ため、
  //       渡されたときのみ表示する
  onReauthenticate?: () => void;
};

export const ErrorScreen = ({
  message,
  showHomeLink,
  onSelectWorkspace,
  onReauthenticate,
}: ErrorScreenProps) => {
  const hasHomeLink = showHomeLink === true && homeHost != null;
  const hasActions =
    onReauthenticate != null || onSelectWorkspace != null || hasHomeLink;

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-12 px-4 text-center text-muted-foreground">
      <div className="flex flex-col items-center gap-4">
        <AlertCircle className="size-12" aria-hidden />
        <p className="text-lg">{message}</p>
      </div>
      {hasActions && (
        <div className="flex flex-col items-center gap-4">
          {onSelectWorkspace != null && (
            <Button variant="outline" onClick={onSelectWorkspace}>
              別のワークスペースを選ぶ
            </Button>
          )}
          {onReauthenticate != null && (
            <Button variant="outline" onClick={() => onReauthenticate()}>
              ログアウトして再ログイン
            </Button>
          )}
          {hasHomeLink && (
            <a href={homeHost} className="underline underline-offset-4">
              Speria ホームに戻る
            </a>
          )}
        </div>
      )}
    </main>
  );
};
